export default __webpack_public_path__ + "static/media/Incidents-6.665ea93a.png";